<template>

    <Anchor :route="link" external :aria-label="`Social Media Link ${name}`">

        <div class="social-media" :class="[ `--${ name }`, { '--large': large } ]">

            <div class="social-media__icon">

                <component :is="name"/>

            </div>

        </div>

    </Anchor>

</template>

<script lang="ts">

    import Anchor from './Anchor.vue'
    import Instagram from './Logos/Social/Instagram.vue'
    import LinkedIn from './Logos/Social/LinkedIn.vue'
    import YouTube from './Logos/Social/YouTube.vue'

    export default {
        name: 'SocialMediaButton',
        components: {
            Instagram, LinkedIn, YouTube, Anchor
        },
        props: {
            name: { type: String, required: true },
            link: { type: String, required: true },
            large: { type: Boolean, default: false }
        }
    }

</script>

<style lang="scss">

    @include component(social-media) {

        @apply flex justify-center items-center cursor-pointer;

        width: 40px;
        height: 40px;

        @include option(large) {

            width: 100%;
            height: 100px;

            @screen md {

                width: 100px;

            }

        }

        @include option(LinkedIn) {

            transition: background 250ms ease;

            path {

                fill: white;

            }

            &:hover {

                background: #1052B8;

                path {

                    fill: white;

                }

            }

        }

        @include option(Instagram) {

            @apply relative;

            svg {

                @apply absolute;

            }

            path {

                fill: white;

            }

            &:before {

                @apply absolute opacity-0;

                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background: linear-gradient(34.26deg, #CD0040 7.63%, #AA0096 94.72%);
                transition: opacity 250ms ease;
                content: '';

            }

            &:hover {

                &:before {

                    @apply opacity-100;

                }

                path {

                    fill: white;

                }

            }

        }

        @include part(icon) {

            @apply flex items-center justify-center w-6 h-6;

            path {

                fill: white

            }

        }

    }

</style>
